<main class="cv-preview">
  <section
    #cvToDownload
    class="cv-wrapper"
  >
    <!-- Original: <app-template12 [data]="userDetails"></app-template12> -->
    <app-template5 [data]="userDetails"></app-template5>
  </section>

  <section>
    <ng-container>
      <div class="cv-ready-message">
        <h2>YOUR CV IS READY</h2>
        <p>
          Congratulations, you have successfully built a CV. before you go on
          applying for your dream jobs we suggest you boost your chances by
          getting your CV reviewed by our professional recruiters.
        </p>
      </div>

      <div class="cv-action-buttons">
        <button
          class="cv-review-btn"
          type="button"
          (click)="requestCvReview()"
          [disabled]="isLoading"
        >
          <ng-container *ngIf="isLoading"> ANALYSING... </ng-container>
          <ng-container *ngIf="!isLoading">REQUEST CV REVIEW</ng-container>
        </button>

        <button
          class="cv-download-btn"
          type="button"
          (click)="downloadCv()"
          [disabled]="isDownloading"
        >
          <ng-container *ngIf="isDownloading"> DOWNLOADING... </ng-container>
          <ng-container *ngIf="!isDownloading">
            DOWNLOAD WITHOUT REVIEW
          </ng-container>
        </button>
      </div>
    </ng-container>
  </section>
</main>

<!-- <div *ngIf="!userDetails">
  <p>Data related to CV not found</p>
</div> -->
